import React from 'react';
import { useLocation } from 'react-router-dom';
import NotificationBell from '../Notifications/NotificationBell';
import ListMatchAlerts from '../Notifications/ListMatchAlerts';
import UserMenu from './UserMenu';
import './AppHeader.css';

// pathname → human-readable page name. Order matters for prefix matches:
// more specific paths first, fallback at the end.
const PATH_TITLES = [
  ['/dashboard',                'Dashboard'],
  ['/Pips/pips',                'PIPs'],
  ['/un-sanctions',             'UN Sanctions'],
  ['/customers',                'KYC'],
  ['/cases',                    'Cases'],
  ['/transactions',             'Transactions'],
  ['/tm-alerts',                'TM Alerts'],
  ['/tm-rules',                 'TM Rules'],
  ['/str-reports',              'STR Reports'],
  ['/customer-reviews',         'CDD Reviews'],
  ['/audit',                    'Audit Trail'],
  ['/pip-search-history',       'PIP Search History'],
  ['/feedback',                 'Feedback'],
  ['/datacapturer',             'Data Capturer'],
  ['/administrator/manageusers',         'Manage Users'],
  ['/administrator/manageroles',         'Manage Roles'],
  ['/administrator/manageorganisations', 'Manage Organisations'],
  ['/administrator/ManageOrganisations', 'Manage Organisations'],
  ['/administrator/managepackages',      'Manage Packages'],
  ['/administrator/invoices',            'Invoices'],
  ['/administrator/messages',            'Messages'],
  ['/administrator/manage-permissions',  'Manage Permissions'],
  ['/administrator',                     'Administrator']
];

function titleFor(pathname) {
  const lower = (pathname || '').toLowerCase();
  for (const [prefix, label] of PATH_TITLES) {
    if (lower === prefix.toLowerCase() || lower.startsWith(prefix.toLowerCase() + '/')) {
      return label;
    }
  }
  return 'PIP Intel';
}

function AppHeader() {
  const location = useLocation();
  const title = titleFor(location.pathname);

  return (
    <>
      <header className="app-header">
        <h1 className="app-header__title">{title}</h1>
        <div className="app-header__actions">
          <NotificationBell />
          <UserMenu />
        </div>
      </header>
      <ListMatchAlerts />
    </>
  );
}

export default AppHeader;
